export const SUBMIT_CREATE_BENCHMARK_REQUEST =
  "SUBMIT_CREATE_BENCHMARK_REQUEST";

export const SUBMIT_CREATE_BENCHMARK_SUCCESS =
  "SUBMIT_CREATE_BENCHMARK_SUCCESS";

export const SUBMIT_CREATE_BENCHMARK_FAILURE =
  "SUBMIT_CREATE_BENCHMARK_FAILURE";

export const submitCreateBenchmarkRequest = (payload) => ({
  type: SUBMIT_CREATE_BENCHMARK_REQUEST,
  payload,
});

export const submitCreateBenchmarkSuccess = (data) => ({
  type: SUBMIT_CREATE_BENCHMARK_SUCCESS,
  payload: data,
});

export const submitCreateBenchmarkFailure = (error) => ({
  type: SUBMIT_CREATE_BENCHMARK_FAILURE,
  payload: error,
});
